const messageKeys = [
  'search.modal.title',
  'search.button',
  'trending.modal.form.title',
  'trending.modal.form.subtitle',
  'trending.modal.form.error',

  'datepicker.checkin',
  'datepicker.checkout',
  'datepicker.dates.label',
  'datepicker.clear',
  'datepicker.done',

  'guest.selector.title',
  'guest.selector.adult',
  'guest.selector.adults',
  'guest.selector.child',
  'guest.selector.children',
  'guest.selector.pets',
  'guest.selector.guest',
  'guest.selector.guests',
  'guest.selector.pets.yes',
  'guest.selector.pets.no',
  'guest.selector.clear',
  'guest.selector.apply',
  'guest.modal.title',
  'guest.modal.continue',
  'guest.modal.petmessage',

  'trending.modal.form.checkbox.unknowdates.label'
];

const getLabels = (
  mobileTitle,
  buttonTitle,
  modalTitle,
  modalSubtitle,
  modalDefaultErrorMsg,

  checkIn,
  checkOut,
  dates,
  labels,
  done,

  label,
  adult,
  adults,
  child,
  children,
  pets,
  guest,
  guests,
  yesBtn,
  noBtn,
  clearBtn,
  applyBtn,
  modalGuestPickerTitle,
  mobileBtn,
  petMessage,

  checkboxLabel
) => ({
  mobileTitle,
  buttonTitle,
  modalTitle,
  modalSubtitle,
  modalDefaultErrorMsg,
  datePickerLabels: {
    checkIn,
    checkOut,
    dates,
    labels,
    done
  },
  guestsLabels: {
    label,
    adult,
    adults,
    child,
    children,
    pets,
    guest,
    guests,
    yesBtn,
    noBtn,
    clearBtn,
    applyBtn,
    modalGuestPickerTitle,
    mobileBtn,
    petMessage
  },
  checkboxLabel
});

export {
  messageKeys,
  getLabels
};



// WEBPACK FOOTER //
// ./src/universal/components/Trending/translations.js